import React from "react";
import { Navigate, Outlet } from "react-router";

const ProtectedRoute = ({ isAllowed, children }) => {
    if (!isAllowed) {
        return <Navigate to="/" replace></Navigate>;
    }
    return children ? children : <Outlet />;
};

export default ProtectedRoute;
